export const booleanFieldNames = [
  "organisationLead",
  "displayOnWpListingPage",
  "sendEmailOnClientFunding"
];

export const isBooleanField = (name) => booleanFieldNames.includes(name);

export const percentageFieldNames = [
  "industryCategoryId",
  "annualRate",
  "extraAnnualRate",
  "extraFlatRate",
  "flatRate"
];

export const isPercentageField = (name) => percentageFieldNames.includes(name);

export const applicableFieldNames = [
  "maxApplicableValue",
  "minApplicableValue"
];

export const isApplicableField = (name) => applicableFieldNames.includes(name);

export const ALLOWED_STATES = [
  "NSW",
  "QLD",
  "WA",
  "SA",
  "NT",
  "ACT",
  "TAS",
  "VIC"
];
